import React, { FC } from 'react';
import { useTranslations } from 'app/hooks/useTranslations';
import { removeRecentCity } from 'app/store/thunk/location/removeRecentCityThunk';
import { Icon, IconClose } from 'app/icons';
import { CloseButton } from '@flixbus/honeycomb-react';
import { useAppDispatch } from 'app/hooks/appHooks';

export const RemoveButton: FC<{
  cityId: string;
  cityName: string;
  direction: 'from' | 'to';
}> = ({ cityId, direction, cityName }) => {
  const dispatch = useAppDispatch();
  const { getRemoveLabel } = useTranslations({
    getRemoveLabel: 'search_mask.label.remove',
  });

  return (
    <CloseButton
      aria-label={`${getRemoveLabel()}: ${cityName}`}
      display="square"
      onClick={(e) => {
        e.stopPropagation();
        dispatch(removeRecentCity({ direction, cityId }));
        document.getElementById(`searchInput-${direction}`)?.focus();
      }}
      onKeyDown={(e: React.SyntheticEvent) => {
        e.stopPropagation();
      }}
    >
      <Icon appearance="primary" InlineIcon={IconClose} />
    </CloseButton>
  );
};
